import { Box, Button, Grid, Paper, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appStates, setAppState } from "../redux/features/appStateSlice";
import { resetConnectBusinessState } from "../redux/features/connectBusinessStateSlice";
import { useModals } from "../context/ModalContext";
import { ConnectBusinessExpandNoEmployees } from "./connectBusinessExpandNoEmployees";
import { connectBusinessFlowSx } from "./connectBusinessFlowStyles";
import { EmployeeBasicCard } from "./employeeBasicCard";
import { QuickBadge } from "./QuickBadge";

export const ConnectEmployeeTres = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [areFilteredCleaners, setAreFilteredCleaners] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { closeByKey } = useModals();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const connectBusinessState = useSelector((state) => state.connectBusinessState);
  const { serviceType, residentialServices, commercialServices, bestChoices, requirements } = connectBusinessState;

  const [employees, setEmployees] = useState([]);

  const handleFilterBestChoices = () => {
    const services = serviceType === "commercial" ? commercialServices : residentialServices;
    const serviceIds = Object.entries(services || {})
      .filter(([, isChecked]) => isChecked)
      .map(([id]) => Number(id));
    const requirementIds = requirements?.map((r) => r.id);

    const filteredBestChoices = bestChoices
      .filter((bc) => {
        const hasServices = serviceIds.length > 0;
        const hasRequirements = requirementIds.length > 0;

        const serviceMatch = hasServices ? bc.workTypeServices?.some((wts) => serviceIds.includes(wts.id)) : true;

        const requirementsMatch = hasRequirements ? requirementIds.every((reqId) => bc.requirements?.some((r) => r.id === reqId)) : true;

        return serviceMatch && requirementsMatch;
      })
      .sort((a, b) => (a?.distances?.driving?.duration || 0) - (b?.distances?.driving?.duration || 0));

    if (filteredBestChoices.length === 0) setAreFilteredCleaners(false);
    setEmployees(filteredBestChoices);
  };

  useEffect(() => {
    handleFilterBestChoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = () => {
    if (connectBusinessState.isDemo) {
      dispatch(resetConnectBusinessState());
      closeByKey("FlowHub-FindExpert");
      return;
    }

    dispatch(resetConnectBusinessState());
    dispatch(setAppState({ currState: appStates.HOME }));
    navigate("/business");
  };

  return (
    <Box
      sx={{
        ...connectBusinessFlowSx.shell,
      }}
    >
      {areFilteredCleaners ? (
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            ...connectBusinessFlowSx.panel,
            overflow: "hidden",
          }}
        >
          {/* Bandera azul */}

          <Typography
            variant="h5"
            fontWeight={700}
            sx={{
              textAlign: "center",
              ...connectBusinessFlowSx.title,
            }}
          >
            Experts near you
          </Typography>

          {/* Contenido */}
          <Box sx={{ p: { xs: 3, md: 4 } }}>
            {/* Lista de empleados */}
            <Box
              sx={{
                p: { xs: 2, md: 3 },
                ...connectBusinessFlowSx.contentBand,
              }}
            >
              <Grid container spacing={isSmallScreen ? 2 : 3} direction={isSmallScreen ? "column" : "row"} justifyContent="center">
                {employees?.map((employee, index) => (
                  <Grid
                    item
                    key={index}
                    sx={{
                      transition: "transform 220ms ease",
                      transform: index === currentIndex ? "scale(1.02)" : "scale(1)",
                      "&:hover": { transform: "scale(1.03)" },
                    }}
                  >
                    <EmployeeBasicCard children={index === 0 ? <QuickBadge /> : <></>} {...employee} distance={employee.distances} />
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Botón cancelar */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                onClick={handleCancel}
                variant="outlined"
                sx={{
                  mt: 1,
                  width: { xs: "100%", sm: "auto" },
                  ...connectBusinessFlowSx.secondaryButton,
                  px: 2,
                  py: 1.25,
                  "&:hover": {
                    ...connectBusinessFlowSx.secondaryButton["&:hover"],
                  },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Paper>
      ) : (
        <ConnectBusinessExpandNoEmployees message="We couldn't find any cleaner in your area with your selected filters" />
      )}
    </Box>
  );
};
